import Cache from "./Cache";

const cache = new Cache();

export default cache;
